<template>
  <!-- 登录页 -->
  <div class="login">
    <img src="../../assets/imgs/bm1.png" width="100%" height="90%" />
    <div class="foot-box mt20">
      <!-- <p>海富幼儿园采购网</p> -->
      <p>沪ICP备20000611号-1</p>
    </div>
    <div class="login-box">
      <!-- <div class="tabs">
        <span class="TEACHER" :class="loginType === 'TEACHER' ? 'login-active' : ''"
          @click="loginType = 'TEACHER'">教师登录</span>
        <span class="STUDENT" :class="loginType === 'STUDENT' ? 'login-active' : ''"
          @click="loginType = 'STUDENT'">学生登录</span>
      </div> -->
      <div class="tab_title">
        <span class="STUDENT">采购人登录</span>
      </div>
      <a-form-model id="components-form-demo-normal-login" ref="loginForm" :model="loginForm" :rules="phoneLoginRules"
        class="login-form" @submit="handleSubmit">
        <a-form-model-item label="手机号" prop="phone">
          <a-input size="large" v-model="loginForm.phone" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-row :gutter="8" type="flex" align="bottom">
          <a-col :span="16">
            <a-form-model-item label="验证码" prop="code">
              <a-input size="large" placeholder="请输入验证码" v-model="loginForm.code" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item>
              <a-button size="large" @click="getCaptcha('phoneLogin')">{{ btnTitle }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item>
          <!-- <a-checkbox
            v-decorator="[
          'remember',
          {
            valuePropName: 'checked',
            initialValue: true,
          },
        ]"
          >记住密码</a-checkbox> -->
          <!-- <a class="login-form-forgot" href>忘记密码</a> -->

          <a-button type="link" class="forgetBtn" @click="forgetPwd('forget')">忘记密码</a-button>
          <a-button type="primary" html-type="submit" size="large" :loading="loading" class="login-form-button">登
            录</a-button>
          <div class="login-forget">
            <a-button type="link" class="forgetPwd" @click="forgetPwd('user')">用户名登录</a-button>
            <a-button type="link" class="forgetPwd" @click="register">立即注册</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="aa" ref="aa">
      <a-modal width="40%" title="请选择用户进行登录" :visible="userTimeVisible" @cancel="handleCancel" dialogClass="dialog"
        :footer="null" :getContainer="() => this.$refs.aa">
        <a-spin tip="正在登录中..." :spinning="spinning">
          <ul class="oul">
            <li v-for="(item, index) in userList" :key="index" @click="getPhoneLogin(item.id)">
              <img src="../../assets/imgs/avatar.png" alt="" />
              <p>{{ item.nickname }}</p>
            </li>
          </ul>
        </a-spin>
      </a-modal>
    </div>
    <a-modal :title="modalTitle" :visible="userVisible" @ok="handleModalConfirm" @cancel="handleModalCancel" ok-text="确认"
      cancel-text="取消" width="450px" v-if="userVisible">
      <a-form-model :model="forgetPwdForm" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="用户名" prop="username" v-if="type === 'user'">
          <a-input v-model="forgetPwdForm.username" placeholder="请输入用户名">
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password" v-if="type === 'user'">
          <a-input v-model="forgetPwdForm.password" type="password" placeholder="请输入密码">
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="phone" v-if="type === 'forget' || type === 'register'">
          <a-input v-model="forgetPwdForm.phone" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="code" v-if="type === 'forget' || type === 'register'">
          <a-row :gutter="8">
            <a-col :span="12">
              <a-input placeholder="请输入验证码" v-model="forgetPwdForm.code" />
            </a-col>
            <a-col :span="12">
              <a-button @click="getCaptcha()">{{ btnTitle }}</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="newPwd" v-if="type === 'forget'">
          <a-input v-model="forgetPwdForm.newPwd" placeholder="请输入新密码" type="password" />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="new" v-if="type === 'forget'">
          <a-input v-model="forgetPwdForm.new" placeholder="请输入新密码" type="password" />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="pwd" v-if="type === 'register'">
          <a-input v-model="forgetPwdForm.pwd" placeholder="请输入密码" type="password" />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="confirmPwd" v-if="type === 'register'">
          <a-input v-model="forgetPwdForm.confirmPwd" placeholder="请输入密码" type="password" />
        </a-form-model-item>
        <a-form-model-item label="选择学校" prop="remark" v-if="type === 'register'">
          <a-select show-search optionFilterProp="title" placeholder="请选择学校" @change="handleSchoolChange">
            <a-select-option v-for="blocs in schoolList" :key="blocs.id" :value="blocs.name" :title="blocs.name">{{
              blocs.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import md5 from 'md5'
import { getMsgCode, codeChangePassword, getPhoneLogin } from '@/serve/auth'
import { getCode, registerUser, checkPhone } from '@/serve/schools'
import { getSchool } from "@/serve/open";
export default {
  name: 'login',
  data() {
    return {
      userTimeVisible: false,
      userList: [],
      type: '',
      spinning: false,
      form: this.$form.createForm(this, { name: 'normal_login' }),
      loginType: 'TEACHER',
      loading: false,
      timer: null,
      phoneLoginRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        new: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPwd: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      userVisible: false,
      isFlag: false,
      loginForm: {
        phone: '',
        code: '',
      },
      forgetPwdForm: {
        phone: '',
        code: '',
        newPwd: '',
        new: '',
        pwd: '',
        confirmPwd: '',
        remark: ''
      },
      btnTitle: '获取验证码',
      modalTitle: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      schoolList: []
    }
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    ...mapActions(['Login', 'GetInfo']),
    forgetPwd(flag) {
      if (flag == 'user') {
        this.modalTitle = '用户名登录'
      } else {
        this.modalTitle = '忘记密码'
      }
      this.userVisible = true
      this.type = flag
    },
    register() {
      this.modalTitle = '注册账户'
      this.userVisible = true
      this.type = 'register'
    },
    handleCancel() {
      this.userTimeVisible = false
    },
    handleModalCancel() {
      this.userVisible = false
      this.$refs.ruleForm.resetFields()
    },
    getSchoolList() {
      getSchool().then((res) => {
        if (res) {
          res.unshift({ id: 'qt', name: '其他' });
        }
        this.schoolList = res;
      });
    },
    handleSchoolChange(value) {
      this.forgetPwdForm.remark = value;
    },
    // 手机号登录
    getPhoneLogin(userId = '') {
      this.loading = true;
      let params = {
        clientType: 'USER_SCHOOL_CLIENT',
        code: this.loginForm.code,
        phone: this.loginForm.phone,
        userId
      }
      if (userId) {
        this.spinning = true
      }
      getPhoneLogin(params)
        .then(res => {
          // 若为true则绑定用户只有一个
          if (res.token) {
            this.GetInfo(res.token)
              .then(() => {
                this.loading = false;
                this.spinning = false;
                this.$message.success('登录成功！');
                setTimeout(() => {
                  this.$router.push('/')
                }, 500);
              })
              .catch(err => {
                this.loading = false;
                this.spinning = false
                this.$message.error(err.data.message)
              })
          } else {
            this.userList = res.users
            this.userTimeVisible = true
          }
          this.userVisible = false
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.data.message)
        })
    },
    // 获取验证码
    async getCaptcha(type) {
      if (type) {
        if (!this.loginForm.phone.trim() || !/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.loginForm.phone)) {
          return this.$message.error('请输入合法手机号')
        } else {
          //验证手机号是否注册
          let checkRes = await checkPhone({ phone: this.loginForm.phone.trim() });
          if (!checkRes) {
            this.$message.warning("手机号不存在，请先注册！");
            this.register();
            return;
          }
        }
      } else {
        if (!this.forgetPwdForm.phone.trim() || !/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.forgetPwdForm.phone)) {
          return this.$message.error('请输入合法手机号')
        }
      }

      if (this.isFlag) return
      this.isFlag = true
      let time = 60
      let params
      if (type === 'phoneLogin') {
        params = {
          phone: this.loginForm.phone,
          type: 'LOGIN_CONFIRM',
          roleType: 'STUDENT'
        }
      } else {
        params = {
          phone: this.forgetPwdForm.phone,
          type: 'CHANGE_PASSWORD',
          roleType: 'STUDENT'
        }
      }
      if (this.type == 'register') {
        //注册获取验证码
        params = {
          phone: this.forgetPwdForm.phone,
          type: 'REGISTER',
        }

        getCode(params).then(res => {
          this.timer = setInterval(() => {
            if (time > 0) {
              time--
              this.btnTitle = `${time}秒后重试`
            } else {
              this.btnTitle = '获取验证码'
              this.isFlag = false
              clearInterval(this.timer)
            }
          }, 1000)
        }).catch(err => {
          if ((err.status === 404 || err.status === 400) && !err.data.success) {
            this.$message.error(err.data.message)
          }
          this.btnTitle = '获取验证码'
          this.isFlag = false
          clearInterval(this.timer)
        })
      } else {
        getMsgCode(params)
          .then(() => {
            this.timer = setInterval(() => {
              if (time > 0) {
                time--
                this.btnTitle = `${time}秒后重试`
              } else {
                this.btnTitle = '获取验证码'
                this.isFlag = false
                clearInterval(this.timer)
              }
            }, 1000)
          })
          .catch(err => {
            if ((err.status === 404 || err.status === 400) && !err.data.success) {
              this.$message.error(err.data.message)
            }
            this.btnTitle = '获取验证码'
            this.isFlag = false
            clearInterval(this.timer)
          })
      }
    },
    handleModalConfirm(formName) {
      if (this.type === 'login') {
        //手机号登录 
        if (!this.forgetPwdForm.phone || !this.forgetPwdForm.code) {
          return this.$message.error('请填写完整信息')
        }
        this.getPhoneLogin()
      } else if (this.type === 'user') {
        //用户名登录 
        if (!this.forgetPwdForm.username || !this.forgetPwdForm.password) {
          return this.$message.error('请填写完整信息')
        }
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            let params = {
              username: this.forgetPwdForm.username,
              password: md5(this.forgetPwdForm.password),
              type: this.loginType
            }
            this.Login(params)
              .then(() => {
                this.$message.success('登录成功！');
                setTimeout(() => {
                  if (this.$route.query.id) {
                    return this.$router.push(`/product/${this.$route.query.id}`)
                  }
                  this.$router.push('/')
                }, 500);
              })
              .catch(err => {
                this.$message.error(err.data.message);
              })
          }
        })
      } else if (this.type === 'forget') {
        //忘记密码
        this.$refs.ruleForm.validate(valid => {
          if (this.forgetPwdForm.newPwd !== this.forgetPwdForm.new && this.forgetPwdForm.newPwd) {
            this.forgetPwdForm.new = ''
            return this.$message.error('两次密码输入不一致,请重新输入')
          }
          if (this.forgetPwdForm.newPwd.length < 6) {
            return this.$message.error('密码至少需要6位字符')
          }
          if (valid) {
            let params = {
              code: this.forgetPwdForm.code,
              phone: this.forgetPwdForm.phone,
              newPwd: md5(this.forgetPwdForm.newPwd),
              roleType: 'STUDENT'
            }
            codeChangePassword(params)
              .then(() => {
                this.$message.success('重置密码成功！')
                this.userVisible = false
                this.forgetPwdForm = {
                  phone: '',
                  code: '',
                  newPwd: '',
                  new: ''
                }
                this.btnTitle = '获取验证码'
                this.isFlag = false
                clearInterval(this.timer)
              })
              .catch(err => {
                if ((err.status === 404 || err.status === 400) && !err.data.success) {
                  this.$message.error(err.data.message)
                }
                this.btnTitle = '获取验证码'
                this.isFlag = false
                clearInterval(this.timer)
              })
          }
        })
      } else {
        //注册新用户
        this.$refs.ruleForm.validate(valid => {
          if (this.forgetPwdForm.pwd !== this.forgetPwdForm.confirmPwd && this.forgetPwdForm.pwd) {
            this.forgetPwdForm.confirmPwd = ''
            return this.$message.error('两次密码输入不一致,请重新输入')
          }
          if (this.forgetPwdForm.pwd.length < 6) {
            return this.$message.error('密码至少需要6位字符')
          }
          if (valid) {
            let params = {
              code: this.forgetPwdForm.code,
              phone: this.forgetPwdForm.phone,
              password: md5(this.forgetPwdForm.pwd),
              type: 'REGISTER',
              username: this.forgetPwdForm.phone,
              remark: this.forgetPwdForm.remark
            }
            console.log("=========>>>用户注册", params);

            registerUser(params).then(res => {
              this.$message.success('注册成功！')
              this.userVisible = false
              this.forgetPwdForm = {
                phone: '',
                code: '',
                pwd: '',
                confirmPwd: ''
              }
              this.btnTitle = '获取验证码'
              this.isFlag = false
              clearInterval(this.timer)
            }).catch(err => {
              console.log("==========>>>err2", err);
              if ((err.status === 404 || err.status === 400) && !err.data.success) {
                this.$message.error(err.data.message)
              }
              this.btnTitle = '获取验证码'
              this.isFlag = false
              clearInterval(this.timer)
            })
          }
        })
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.getPhoneLogin();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  height: 100%;

  // background: url("../../assets/imgs/bm.png") no-repeat;
  .forgetPwd {
    float: right;
    margin-top: 10px;
  }

  .forgetBtn {
    float: right;
    margin-bottom: 5px;
  }

  .dialog {
    .oul {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 0;
      flex-wrap: wrap;

      li {
        margin: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        padding: 10px;
        transition: all 0.2s ease-in;

        &:hover {
          border: 2px solid #fb921c;
          cursor: pointer;
          transform: scale(1.1);
        }

        p {
          margin: 10px auto;
        }
      }
    }
  }

  .tabs {
    height: 50px;
    background: #e8e8e8;
    border-radius: 5px 5px 0 0;
    color: #9e9e9e;

    .TEACHER,
    .STUDENT {
      display: inline-block;
      text-align: center;
      width: 50%;
      line-height: 50px;
      font-size: 18px;
      font-weight: 700;
      cursor: pointer;
    }

    .login-active {
      background: #fff;
      color: #000;
      border-radius: 5px 5px 0px 0px;
    }
  }

  .tab_title {
    height: 50px;
    background: #e8e8e8;
    border-radius: 5px 5px 0 0;
    color: #9e9e9e;

    &>span {
      color: #000;
      display: inline-block;
      text-align: center;
      width: 100%;
      line-height: 50px;
      font-size: 18px;
      font-weight: 700;
    }
  }

  .login-box {
    position: absolute;
    right: 10%;
    top: 15%;
    width: 400px;
  }

  #components-form-demo-normal-login.login-form {
    background: #fff;
    border: 1px solid #ccc;
    border-top: 0px;
    border-radius: 0 0 5px 5px;
    padding: 20px 30px;
    max-width: 400px;

    .login-forget {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  #components-form-demo-normal-login .login-form-forgot {
    float: left;
  }

  #components-form-demo-normal-login .login-form-button {
    width: 100%;
    background: #1aa5ff;
    height: 50px;
    border: #1aa5ff;
    box-shadow: 0px 2px 11px #ccc;
  }

  .foot-box {
    background: #e8e8e8;
    padding: 20px 0;
    height: 10%;
    text-align: center;
  }
}
</style>
